export default __webpack_public_path__ + "static/media/one_tap_logo_white.e2916286.svg";